import { useState } from "react";
import { UserRound } from "lucide-react";

export const AdminAvatar = ({ src, name, testId, size = "normal" }) => {
  const [failed, setFailed] = useState(false);
  if (src && !failed) return <img className={`admin-avatar ${size}`} src={src} alt={`${name || "User"} avatar`} onError={() => setFailed(true)} data-testid={testId} />;
  return <span className={`admin-avatar fallback ${size}`} aria-label={`${name || "User"} has no avatar`} data-testid={testId}><UserRound size={size === "small" ? 14 : 18} /></span>;
};